// @flow

import { observer } from "mobx-react";
import React from "react";

import UserStore from "app/stores/UserStore";
import VideoStore from "app/stores/VideoStore";

import VideoStatus from "app/components/VideoStatus/VideoStatus";

@observer
export default class VideoStatusContainer extends React.Component<*> {
    render() {
        return (
            <VideoStatus
                user={UserStore.user}
                video={VideoStore.video}
                lastVersion={VideoStore.lastVersionVideo.version}
                lastPublishedVersion={VideoStore.lastPublishedVersion}
                lastSaved={VideoStore.lastSaved}
                publishable={VideoStore.isPublishable}
                onPublish={VideoStore.publish}
                deleting={VideoStore.deleting}
                onDelete={VideoStore.delete}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/VideoStatusContainer.js